/**
 * @copyright 2023 Honda Motor Co., Ltd. All rights reserved.
 */

import "react-datepicker/dist/react-datepicker.css";
import { FC, useState } from "react";
import { useAuth0, withAuthenticationRequired } from "@auth0/auth0-react";
import { PermissionToken } from "components/Common/PermissionToken";
import { Router } from "components/Common/Router";
import { ProjectList } from "components/Project/ProjectList";
import { SpinnerBack } from "components/Common/SpinnerBack";
import { MapDataProvider } from "context/MapDataProvider";
import { TaskDataProvider } from "context/TaskDataProvider";
import { Route, Routes } from "react-router-dom";
import ResetPasswordScreen from "components/LoginHelp/ResetPasswordScreen";
import { OrientationWarningDialog } from "components/Common/OrientationWarningDialog";
import { Const } from "const";
import { AwvDataProvider } from "context/AwvDataProvider";
import { ProjectInfo } from "context/UserContext";

const Permission = withAuthenticationRequired(PermissionToken);

export const App: FC = () => {
  const { isLoading } = useAuth0();
  const [jobsite, setJobsite] = useState<ProjectInfo>();

  if (isLoading) {
    return <SpinnerBack />;
  }

  if (window.location.pathname === Const.path.unlock) {
    return (
      <>
        <Routes>
          <Route path={Const.path.unlock} element={<ResetPasswordScreen />} />
        </Routes>
      </>
    );
  }

  return (
    <>
      <Permission>
        {jobsite ? (
          <MapDataProvider>
            <AwvDataProvider>
              <TaskDataProvider>
                <Router jobsite={jobsite} setJobsite={setJobsite} />
              </TaskDataProvider>
            </AwvDataProvider>
          </MapDataProvider>
        ) : (
          <ProjectList
            open={!jobsite}
            onSelected={(site) => {
              setJobsite(site);
            }}
          />
        )}
      </Permission>
      <OrientationWarningDialog />
    </>
  );
};
